<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        origin="top center"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Komentarz do zamówienia {{ orderNumber }}
                </h1>
            </v-card-title>
            <v-card-text>
                <v-textarea
                    v-model="commentText"
                    label="Dodaj komentarz"
                    auto-grow
                    clearable
                    hide-details
                />
            </v-card-text>
            <v-divider />
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Zapisz"
                    :disabled="commentText === null || commentText.length <= 0"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

export default {
    name: 'AddCommentOrderDialog',
    props: {
        isOpen: {
            type: Boolean
        },
        orderNumber: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            commentText: '',
        }
    },
    methods: {
        onSave() {
            this.$emit('on-save', this.commentText)
            this.onClose()
        },
        onClose() {
            this.$emit('on-close')
            setTimeout(() => {
                this.commentText = ''
            }, 500)
        }
    }
}
</script>
